import {Blocks, TextBlockType} from "@/shared/strapiTypes/common/Blocks";
import {TextContentNode, TextNodeType} from "./CmsTypes";

export const collateText = (nodes: TextContentNode[] | Blocks) => {
	let text = "";
	nodes.forEach((node) => {
		if (node.type === TextNodeType.TEXT || node.type === TextBlockType.TEXT) {
			text += node.text;
			return;
		}

		text += collateText(node.children);
	});

	return text;
};

export const renderVariables = (
	text: string,
	variables: Record<string, any>
): string => {
	return text.replace(/{{\s*([^}]+)\s*}}/g, (match, key) => {
		return variables[key.trim()] ?? match;
	});
};
